module.exports = __webpack_public_path__ + "static/youtube-grey-e5bbaf19a3847f9bfa42db38788b026b.png";